import { render, staticRenderFns } from "./EncuestaPreguntasProlipa.vue?vue&type=template&id=469868a2&scoped=true"
import script from "./EncuestaPreguntasProlipa.vue?vue&type=script&lang=js"
export * from "./EncuestaPreguntasProlipa.vue?vue&type=script&lang=js"
import style0 from "./EncuestaPreguntasProlipa.vue?vue&type=style&index=0&id=469868a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469868a2",
  null
  
)

export default component.exports